import React, {useState} from 'react';
import {View, StyleSheet} from 'react-native';
import {Portal, Dialog, Text, Button, RadioButton, Snackbar} from 'react-native-paper';
import {colors, spacing} from '../../theme';
import {workAssignmentApi} from '../../services/api/workAssignmentApi';

const STATUS_OPTIONS = [
  {label: 'Not Started', value: 'NOT_STARTED'},
  {label: 'Started', value: 'STARTED'},
  {label: 'Completed', value: 'COMPLETED'},
  {label: 'Delete', value: 'DELETED'},
];

const WorkAssignmentStatusDialog = ({visible, onDismiss, assignment, onStatusChanged}) => {
  const [selected, setSelected] = useState(assignment?.status || 'NOT_STARTED');
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({visible: false, message: ''});

  const handleConfirm = async () => {
    if (selected === assignment?.status) {
      onDismiss();
      return;
    }
    setLoading(true);
    try {
      await workAssignmentApi.updateStatus(assignment.id, selected);
      onStatusChanged?.();
      onDismiss();
    } catch (error) {
      const msg = error.response?.data?.message || 'Failed to update status';
      setSnackbar({visible: true, message: msg});
    } finally {
      setLoading(false);
    }
  };

  return (
    <Portal>
      <Dialog visible={visible} onDismiss={onDismiss} style={styles.dialog}>
        <Dialog.Title style={styles.title}>Update Status</Dialog.Title>
        <Dialog.Content>
          <RadioButton.Group onValueChange={setSelected} value={selected}>
            {STATUS_OPTIONS.map(opt => (
              <View key={opt.value} style={styles.radioRow}>
                <RadioButton value={opt.value} color={opt.value === 'DELETED' ? colors.error : colors.primary} />
                <Text style={[styles.radioLabel, opt.value === 'DELETED' && {color: colors.error}]}>
                  {opt.label}
                </Text>
              </View>
            ))}
          </RadioButton.Group>
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={onDismiss} textColor={colors.textSecondary}>Cancel</Button>
          <Button
            mode="contained"
            onPress={handleConfirm}
            loading={loading}
            disabled={loading}
            style={styles.confirmBtn}>
            Confirm
          </Button>
        </Dialog.Actions>
      </Dialog>
      <Snackbar
        visible={snackbar.visible}
        onDismiss={() => setSnackbar({visible: false, message: ''})}
        duration={3000}>
        {snackbar.message}
      </Snackbar>
    </Portal>
  );
};

const styles = StyleSheet.create({
  dialog: {borderRadius: 15},
  title: {fontSize: 18, fontWeight: '700'},
  radioRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: spacing.xs,
  },
  radioLabel: {fontSize: 14, color: colors.text},
  confirmBtn: {backgroundColor: colors.primary, borderRadius: 10, paddingHorizontal: 10},
});

export default WorkAssignmentStatusDialog;
